/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubbrandLookupDto
 */
export interface CreateSubbrandLookupDto {
    /**
     * Unique sub-brand code
     * @type {string}
     * @memberof CreateSubbrandLookupDto
     */
    code: string;
    /**
     * Sub-brand name in English
     * @type {string}
     * @memberof CreateSubbrandLookupDto
     */
    nameEn: string;
    /**
     * Sub-brand name in Arabic
     * @type {string}
     * @memberof CreateSubbrandLookupDto
     */
    nameAr?: string;
    /**
     * Whether the sub-brand is active
     * @type {boolean}
     * @memberof CreateSubbrandLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof CreateSubbrandLookupDto
     */
    sortOrder?: number;
    /**
     * Parent brand lookup ID
     * @type {number}
     * @memberof CreateSubbrandLookupDto
     */
    brandLookupId: number;
}

/**
 * Check if a given object implements the CreateSubbrandLookupDto interface.
 */
export function instanceOfCreateSubbrandLookupDto(value: object): value is CreateSubbrandLookupDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    if (!('brandLookupId' in value) || value['brandLookupId'] === undefined) return false;
    return true;
}

export function CreateSubbrandLookupDtoFromJSON(json: any): CreateSubbrandLookupDto {
    return CreateSubbrandLookupDtoFromJSONTyped(json, false);
}

export function CreateSubbrandLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubbrandLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'brandLookupId': json['brandLookupId'],
    };
}

export function CreateSubbrandLookupDtoToJSON(value?: CreateSubbrandLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'brandLookupId': value['brandLookupId'],
    };
}

